import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlValidatorService {

  // Detect if the URL is suspicious (phishing link)
isSuspiciousUrl(url: string): boolean {
  // Regular expressions to match unsafe protocols and potentially malicious links
  const unsafeProtocols = /^(javascript|data|vbscript|file):/i; // Check for malicious protocols
  const suspiciousPatterns = /([^\w\-\.\/])|(\.(exe|msi|bat|cmd|sh|php|asp|jsp|xml))/i; // Check for suspicious characters or file extensions

  // Check if the URL uses a malicious protocol
  if (unsafeProtocols.test(url)) {
    return true;
  }

  // Check if the URL contains suspicious characters or file types
  if (suspiciousPatterns.test(url)) {
    return true;
  }

  // Additional domain-based phishing detection
  const suspiciousDomains = ['evil.com', 'malicious.com'];
  for (const domain of suspiciousDomains) {
    if (url.includes(domain)) {
      return true;
    }
  }

  return false;
}

}
